window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */


slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

// Ajax Cart Sticky Footer
$( document ).ready(function() {
  $('.ajaxcart-drawer__sticky-footer-button').click(function() {
    $('.btn.ajaxcart__checkout').click();
  });
});


/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Global ================*/
if ((typeof ShopifyAPI) === 'undefined') {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
  };

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + attributeToString(note),
      dataType: 'json',
      beforeSend: function() {
        $body.trigger('beforeUpdateCartNote.ajaxCart', note);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
      },
      error: function(XMLHttpRequest, textStatus) {
        $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery(form).serialize(),
      dataType: 'json',
      beforeSend: function(jqxhr, settings) {
        $body.trigger('beforeAddItem.ajaxCart', form);
      },
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item, form);
        } else {
          ShopifyAPI.onItemAdded(line_item, form);
        }
        $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      },
      error: function(XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function(cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      beforeSend: function() {
        $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
      },
      error: function(XMLHttpRequest, textStatus) {
        $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#page-container')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

/**
 * Mobile Navigation Script
 * ------------------------------------------------------------------------------
 */

theme.MobileNav = (function() {
	var selectors = {
		mobileNavDrawer: '#mobile-nav-drawer'
	};
	var cache = {};

	function init() {
		cacheSelectors();
		initDrawer();
	}

	function cacheSelectors() {
		cache = {
			mobileNavDrawer: $(selectors.mobileNavDrawer)
		};
	}

	function initDrawer() {
		// Add required classes to HTML
		$('.js-drawer-open-left')
			.attr('aria-controls', 'mobile-nav-drawer')
			.attr('aria-expanded', 'false');

		theme.MobileNavDrawer = new theme.Drawers('mobile-nav-drawer', 'left');
	}

	return {
		init: init
	};
})();

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {
  'use strict';
  /*global ShopifyAPI, slate, theme, Handlebars, Shopify */

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;

  var addOnProductId;
  var freeProductId;

  //Handlebars helper for conditionals

  Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
    return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
  });


  /*============================================================================
    PUBLIC METHODS - Initialise the plugin and define global options
  ==============================================================================*/
  function init(options) {

    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: '.ajaxcart__sticky-subtotal-amount .money',
      moneyFormat: '$',
      disableAjaxCart: false,
      enableQtySelectors: true
    };
    

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      _qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      _formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    _adjustCart();
  }

  function loadCart() {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(_cartUpdateCallback);
  }

  /*============================================================================
    PRIVATE METHODS
  ==============================================================================*/
  function _updateCountPrice(cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    
    
    if ($cartCostSelector) {
      $cartCostSelector.html(slate.Currency.formatMoney(cart.total_price, settings.moneyFormat));
    }
  }

  function _formOverride() {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, _itemAddedCallback, _itemErrorCallback);
    });
  }

  function _itemAddedCallback() {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(_cartUpdateCallback);
  }

  function _itemErrorCallback(XMLHttpRequest, textStatus) {
    var data = JSON.parse(XMLHttpRequest.responseText);
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status === 422) {
        $formContainer.after('<div class="errors qty-error">' + data.description + '</div>');
        console.log(data, textStatus);
      }
    }
  }

  function _cartUpdateCallback(cart) {
    // Update quantity and price
    _updateCountPrice(cart);
    _buildCart(cart);
  }

  function _buildCart(cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p class="ajaxcart__empty"> Your cart is currently empty.</p>');
        $(".upsell-section").hide();
        $(".ajaxcart-countdown").hide();
      _cartCallback(cart);
      return;
    }
    else{
      $(".upsell-section").show();
      $(".ajaxcart-countdown").show();
    }

    // handle free products in cart
    if (theme.freeAddOnEnabled) {
      _handleFreeAddOn(cart);
    }

    if (theme.freeProductWithPurchaseEnabled) {
      _handleFreeProduct(cart);
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      if (cartItem.image != null) {
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.id,
        pid: cartItem.product_id,
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title.replace(/(<([^>]+)>)/ig,""),
        phandle: cartItem.product_title.toLowerCase().replace(/ /g,'-').replace(/"/g, ""),
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: slate.Currency.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: slate.Currency.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalPrice: slate.Currency.formatMoney(cartItem.original_price, settings.moneyFormat),
        originalLinePrice: slate.Currency.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
      };

      /* Begin Recharge Code */
      if (cartItem.selling_plan_allocation) {
        item["sellingPlanAllocation"] = cartItem.selling_plan_allocation;
      }
      /* End Recharge Code */
      
      if (item.properties) {
        if ('shipping_interval_frequency' in item.properties){
          item.properties.Frequency = "Every " + item.properties.shipping_interval_frequency + ' ' + item.properties.shipping_interval_unit_type;
          delete item.properties.shipping_interval_frequency
          delete item.properties.shipping_interval_unit_type
          delete item.properties.subscription_id
        }
      }else{
        item.properties = {};
        item.properties.Frequency = 'One-time purchase'
      }

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: slate.Currency.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings + ' ' + slate.Currency.formatMoney(cart.total_discount, settings.moneyFormat),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    };

    $cartContainer.append(template(data));

    _cartCallback(cart);
  }

  function _cartCallback(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }

  function _adjustCart() {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = _validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else if ($el.hasClass('ajaxcart__qty-remove')){
        qty = 0;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
      
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = _validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;
      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');
      var $product = $('.ajaxcart__product[data-line="' + line + '"]').addClass('is-loading');
      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, _adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  }

  function _adjustCartCallback(cart) {
    // Update quantity and price
    _updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(_buildCart);
    }, 150);
  }

  function _createQtySelectors() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#AjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  }

  function _qtySelectors() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr('name'),
          inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = _validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty).trigger('change');
      });
    }
  }

  function _validateQty(qty) {
    if ((parseFloat(qty) === parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  }

  function _handleFreeProduct(cart) {
    var freeProductInCart = false,
        freeProductMinimum = theme.freeProductWithPurchaseMinimum,
        url = '',
        data = {};

    // set free product id
    freeProductId = theme.freeProductWithPurchase.id;

    // check if free product is already in cart
    cart.items.forEach(function(item){
      if (item.id === freeProductId) {
        freeProductInCart = true;
      }
    });

    // add free product if cart total is greater than minimum
    if (cart.total_price >= freeProductMinimum && freeProductInCart === false) {
      data = { 
        quantity: 1, 
        id: freeProductId, 
        properties: {
          'freeItem': true
        } 
      };
      url = '/cart/add.js';
      _postFreeProducts(data, url);
    }

    if (cart.total_price < freeProductMinimum && freeProductInCart === true) {
      data = "updates[" + freeProductId + "]=0";
      url = '/cart/update.js';
      _postFreeProducts(data, url);
    }

  };

  function _handleFreeAddOn(cart) {
    var addOnInCart = false,
        eligibleProductsInCart = false,
        url = '',
        data = {};
  
    // set product id
    addOnProductId = theme.freeAddOnProduct.id;
  
    cart.items.forEach(function(item) {
      theme.freeAddOnEligibleProducts.forEach(function(product) {
        var variantIds = product.variant_ids.split(',');
  
        if (variantIds.indexOf(item.id.toString()) > -1 && !eligibleProductsInCart ) {
          eligibleProductsInCart = true;
        }
      });
  
      if (item.id === addOnProductId) {
        addOnInCart = true;
      }
    });
  
    // add free add-on if eligible products are in cart
    if (!addOnInCart && eligibleProductsInCart) {
      data = { 
        quantity: 1, 
        id: addOnProductId,
        properties: {
          'freeItem': true
        }            
      };
      url = '/cart/add.js';
      _postFreeProducts(data, url);
  
    // remove free add-on if no eligible product in cart
    } else if (addOnInCart && !eligibleProductsInCart) {
      data = "updates[" + addOnProductId + "]=0";
      url = '/cart/update.js';
      _postFreeProducts(data, url);
    }
  };
  
  function _postFreeProducts(data, url) {
    $.ajax({
      type: "POST",
      url: url,
      data: data,
      dataType: 'json'
    }).done(function(){
      ShopifyAPI.getCart(_cartUpdateCallback);
    }).fail(function() {
      ShopifyAPI.getCart(_cartUpdateCallback);
    });
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

window.theme = window.theme || {};

theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
  onDrawerOpen: ajaxCart.load
});

// Init ajax cart
ajaxCart.init({
  formSelector: '.product-form',
  cartContainer: '#CartContainer',
  addToCartSelector: '.product-form__cart-submit',
  cartCountSelector: '.site-header-desktop__bag-counter',
  moneyFormat: theme.moneyFormat,
  // Rebuy Smart Cart adds the item itself; letting this cart add it too doubled the quantity
  disableAjaxCart: true
});

function updateShippingMessage() { 
  var $goalString = $(".ajaxcart-countdown").attr("data-discount-goal")
  var $goal;
  if ($goalString !== undefined){
    $goal = parseInt($(".ajaxcart-countdown").attr("data-discount-goal").replace("$", "").replace(".", "").replace(" ", ""));
  }
  else{
    $goal = 0;
  }
  var $currentTotalString = $(".ajaxcart__subtotal .money");
  var $currentTotal;
  if ( $currentTotalString !== undefined){
    $currentTotal = parseInt($(".ajaxcart__subtotal .money").text().replace("$", "").replace(".", "").replace(" ", ""));
  }
  else{
    $currentTotal = 0;
  }

  if ( isNaN($currentTotal) ){
    $currentTotal = 0;
  }
  var $amountLeft = $goal - $currentTotal;
  
  if ( ($amountLeft > 0 )){
    $(".ajaxcart-countdown__price-left .money").text( "$" + ( $amountLeft / 100).toFixed(2))
    $(".ajaxcart-countdown__no-success").addClass("active");
    $(".ajaxcart-countdown__success").removeClass("active");
  }
  else if ( $amountLeft < 1 ) {
    $(".ajaxcart-countdown__price-left .money").text("$" + ( $goal / 100).toFixed(2));
    $(".ajaxcart-countdown__no-success").removeClass("active");
    $(".ajaxcart-countdown__success").addClass("active");
  }
  
  var $percentage = ( $currentTotal / $goal ) * 100  
  if ( $percentage > 100 ){
    $percentage = 100
  }
  var $percent = $percentage + "%";
  $(".ajaxcart__inner-progress-bar").css("width", $percent)

}

function checkUpsell(){
  $("[js-ajaxcart-normal-product]").each(function(){
    var $this = $(this);
    var $variantId = $this.attr("data-variant-id");

    $("[js-ajaxcart-upsell-product]").each(function(){
      var $this = $(this);
      var $val = $this.find("[data-product-select] option:selected").val();
      if ($val === $variantId){
        $this.addClass("active")
      }
    })

  })
  if ($(".active[js-ajaxcart-upsell-product]").length > 2){
    $(".ajaxcart__upsell-header").hide()
  }
}

$("body").on("click", ".ajaxcart__upsell-btn", function(){
  var $currentTarget = $(this);
  addProduct($currentTarget);
})

function addProduct($currentTarget){
  var $variantId = $currentTarget.attr("data-variant-id")
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data:  'quantity=1&id=' + $variantId,
      id: $variantId,
      quantity: 1,
      error: function(){
          console.log("error")
      },
      success: function(){
        ajaxCart.load();
      }
  })
}

$("body").on("click", ".ajaxcart__promo-btn" , function(e){
  e.preventDefault()
  var $inputVal = $(".ajaxcart__promo-input").val();
  var $location = "/checkout?discount=" + $inputVal

  if ( $inputVal != ""){
    $(location).attr("href", $location)
  }
})

$(document).ready(updateShippingMessage());
// Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM
jQuery(document.body).on('afterCartLoad.ajaxCart', function(evt, cart) {
  updateShippingMessage();
  checkUpsell();
  theme.CartDrawer.open();
});

theme.Accordion = (function(){
  var selectors = {
    header: '[js-accordion-header]',
    content: '[js-accordion-content]'
  }
function Accordion(container) {
    this.$container = $(container);
    this.$header = $(selectors.header, this.$container)
    this.$content = $(selectors.content, this.$container)

    this.$header.on('click', toggleAccordion.bind(this));

    function toggleAccordion(evt) {
      var $el = $(evt.currentTarget)
      if($el.attr('aria-expanded') == 'true'){
        //this stops the slide up triggering the parent;
        $el.siblings().slideUp(400, function() {
          $(this).attr('aria-hidden', true);
        })
        // This is closing the children accordions when the parent accordion is closed.
        $el.siblings(selectors.content).find(selectors.header).each(function(){
              $(this).attr('aria-expanded', false);
              $(this).siblings(selectors.content).slideUp(400, function() {
                  $(this).attr('aria-hidden', true);
              });
        })
        $el.attr('aria-expanded', false);
      } else {
        $el.parent().siblings().children(selectors.content , this.$container).slideUp(0, function(){
          $(this).attr('aria-hidden', true);
        });
        $el.parent().siblings().children(selectors.header , this.$container).attr('aria-expanded', false);
        $el.siblings(selectors.content).slideDown().attr('aria-hidden', false);
        $el.attr('aria-expanded', true);
      }
    }
  }

  return Accordion;
})();
$('document').ready(function(){
  const title_items = $('.product-button-pricing');
  const content_boxs = $('.product-description__accordion-header.content');
  title_items.each(function (i) {
    $(title_items[i]).click(function(){
      $(content_boxs[i]).click();
    });
  });
});
/**
 * Global Configurations
 * ------------------------------------------------------------------------------
 */
theme.config = {
  // Media queries & breakpoints based on src/styles/tools/variables.scss.liquid
  mediaQueries: {
    xs: 'screen and (max-width: 29.99em)',
    smallDown: 'screen and (max-width: 47.99em)',
    small: 'screen and (min-width: 30em) and (max-width: 47.99em)',
    smallUp: 'screen and (min-width: 30em)',
    mediumDown: 'screen and (max-width: 63.99em)',
    medium: 'screen and (min-width: 48em) and (max-width: 63.99em)',
    mediumUp: 'screen and (min-width: 48em)',
    largeDown: 'screen and (max-width: 79.99em)',
    large: 'screen and (min-width: 64em) and (max-width: 79.99em)',
    largeUp: 'screen and (min-width: 64em)',
    widescreen: 'screen and (min-width: 80em)'
  },
  breakpoints: {
    small: 480,
    medium: 768,
    large: 1024,
    widescreen: 1280
  }
};
theme.Header = (function(){
 
    function HeaderFade() {

    // Hide Header on on scroll down
      var didScroll;
      var lastScrollTop = 0;
      var delta = 5;
      var navbarHeight = $('.header').outerHeight();

      $(window).scroll(function(){
          didScroll = true;
      });
      
      function hasScrolled() {
          var scrolledTop = $(this).scrollTop();
          
          // Make sure they scroll more than delta
          if(Math.abs(lastScrollTop - scrolledTop) <= delta) {
            return;
          }
          // If they scrolled down and are past the navbar, scroll up the navbar
          if (scrolledTop > lastScrollTop && scrolledTop > navbarHeight){
              $('.site-header').slideUp();
          } else if(scrolledTop + $(window).height() < $(document).height()) {
              $('.site-header').slideDown();
          } 
          
          lastScrollTop = scrolledTop;
      }

      setInterval(function() {
          if (didScroll) {
              hasScrolled();
              didScroll = false;
          }
      }, 250);

    }

  
    return HeaderFade;
})();

theme.Bar = (function(){
 
    function BarFade() {

    // Hide Header on on scroll down
      var didScroll;
      var lastScrollTop = 0;
      var delta = 5;
      var navbarHeight = $('.header').outerHeight();

      $(window).scroll(function(){
          didScroll = true;
      });
      
      function hasScrolled() {
          var scrolledTop = $(this).scrollTop();
          
          // Make sure they scroll more than delta
          if(Math.abs(lastScrollTop - scrolledTop) <= delta) {
            return;
          }
          // If they scrolled down and are past the navbar, scroll up the navbar
          if (scrolledTop > lastScrollTop && scrolledTop > navbarHeight){
              $('.site-header__promo-bar').slideUp();
          } else if(scrolledTop + $(window).height() < $(document).height()) {
              $('.site-header__promo-bar').slideDown();
          } 
          
          lastScrollTop = scrolledTop;
      }

      setInterval(function() {
          if (didScroll) {
              hasScrolled();
              didScroll = false;
          }
      }, 250);

    }

  
    return BarFade;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    savePriceText: '[data-save-price-text]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.moveAfterpay();
    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    this.slickProductImage();
    this.$container.on('variantChange' + this.namespace, this.filterImage.bind(this));
    this.featuredZoomImage();
    this.reviews();
    this.$container.trigger({
      type: 'variantChange' + this.namespace,
      variant: this.variants.currentVariant
    });
    if ( $(".product-bundle__products.new").length > 0 ){
      this.bundleProducts2()
    } else if ( $(".product-bundle__products").length > 0 ){
      this.bundleProducts()
    }
    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    
    /**
     * Move AFterpay under prices
     *
     */

    moveAfterpay: function() {
      $( window ).load(function() {
        if ($('#product-swatch').length) {
          $(".product-info__form-afterpay-container > .afterpay-paragraph").appendTo("#product__afterpay");
        }
      });
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      let discount_badge_div = $(selectors.savePriceText, this.$container);
const $productPrice = $(selectors.productPrice, this.$container);

// remove all classes starting with "variant-"
$productPrice.removeClass(function(index, className) {
  return (className.match(/\bvariant-\S+/g) || []).join(' ');
});

// create new class
const variantClass = `variant-${variant.title
  .toLowerCase()
  .replace(/\s+/g, '-')
  .replace(/[^\w-]/g, '')}`;

// add new class
$productPrice.addClass(variantClass);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
        if (discount_badge_div) {
          discount_badge_div.html(`<span class="discount-badge">${slate.Currency.formatMoney(variant.compare_at_price - variant.price, theme.moneyFormat)}</span>`);
        }
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
        if(discount_badge_div) {
          discount_badge_div.html('');
        }
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },
    slickProductImage: function(evt){

      enquire.register(theme.config.mediaQueries.largeUp,{
        match: function(){
          if( $(".product-image__thumbnail-image").hasClass("slick-initialized") ){
              $(".product-image__thumbnail-image").slick("unslick");
          }
          $(".product-image__thumbnail-image").slick({
            slidesToScroll: 1,
            slidesToShow: 4,
            arrows: false,
            dots: false,
            focusOnSelect: true,
            arrows: true,
            speed: 100,
            prevArrow: '<button class="product-image__thumbnail-image-prev" aria-label="Previous"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="284.935px" height="284.936px" viewBox="0 0 284.935 284.936" style="enable-background:new 0 0 284.935 284.936;" xml:space="preserve"><g><path d="M110.488,142.468L222.694,30.264c1.902-1.903,2.854-4.093,2.854-6.567c0-2.474-0.951-4.664-2.854-6.563L208.417,2.857 C206.513,0.955,204.324,0,201.856,0c-2.475,0-4.664,0.955-6.567,2.857L62.24,135.9c-1.903,1.903-2.852,4.093-2.852,6.567 c0,2.475,0.949,4.664,2.852,6.567l133.042,133.043c1.906,1.906,4.097,2.857,6.571,2.857c2.471,0,4.66-0.951,6.563-2.857 l14.277-14.267c1.902-1.903,2.851-4.094,2.851-6.57c0-2.472-0.948-4.661-2.851-6.564L110.488,142.468z"/></g></svg></button>',
            nextArrow: '<button class="product-image__thumbnail-image-next" aria-label="Next"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="284.935px" height="284.936px" viewBox="0 0 284.935 284.936" style="enable-background:new 0 0 284.935 284.936;" xml:space="preserve"><g><path d="M222.701,135.9L89.652,2.857C87.748,0.955,85.557,0,83.084,0c-2.474,0-4.664,0.955-6.567,2.857L62.244,17.133 c-1.906,1.903-2.855,4.089-2.855,6.567c0,2.478,0.949,4.664,2.855,6.567l112.204,112.204L62.244,254.677 c-1.906,1.903-2.855,4.093-2.855,6.564c0,2.477,0.949,4.667,2.855,6.57l14.274,14.271c1.903,1.905,4.093,2.854,6.567,2.854 c2.473,0,4.663-0.951,6.567-2.854l133.042-133.044c1.902-1.902,2.854-4.093,2.854-6.567S224.603,137.807,222.701,135.9z"/></g></svg></button>'
          })
        },
        unmatch: function(){
        }
      }).register(theme.config.mediaQueries.mediumDown, {
      match: function(){
          if( $(".product-image__thumbnail-image").hasClass("slick-initialized") ){
              $(".product-image__thumbnail-image").slick("unslick");
          }
          $(".product-image__thumbnail-image").slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            arrows: false,
            dots: false,
            focusOnSelect: true,
            arrows: true,
            speed: 100,
            prevArrow: '<button class="product-image__thumbnail-image-prev" aria-label="Previous"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="284.935px" height="284.936px" viewBox="0 0 284.935 284.936" style="enable-background:new 0 0 284.935 284.936;" xml:space="preserve"><g><path d="M110.488,142.468L222.694,30.264c1.902-1.903,2.854-4.093,2.854-6.567c0-2.474-0.951-4.664-2.854-6.563L208.417,2.857 C206.513,0.955,204.324,0,201.856,0c-2.475,0-4.664,0.955-6.567,2.857L62.24,135.9c-1.903,1.903-2.852,4.093-2.852,6.567 c0,2.475,0.949,4.664,2.852,6.567l133.042,133.043c1.906,1.906,4.097,2.857,6.571,2.857c2.471,0,4.66-0.951,6.563-2.857 l14.277-14.267c1.902-1.903,2.851-4.094,2.851-6.57c0-2.472-0.948-4.661-2.851-6.564L110.488,142.468z"/></g></svg></button>',
            nextArrow: '<button class="product-image__thumbnail-image-next" aria-label="Next"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="284.935px" height="284.936px" viewBox="0 0 284.935 284.936" style="enable-background:new 0 0 284.935 284.936;" xml:space="preserve"><g><path d="M222.701,135.9L89.652,2.857C87.748,0.955,85.557,0,83.084,0c-2.474,0-4.664,0.955-6.567,2.857L62.244,17.133 c-1.906,1.903-2.855,4.089-2.855,6.567c0,2.478,0.949,4.664,2.855,6.567l112.204,112.204L62.244,254.677 c-1.906,1.903-2.855,4.093-2.855,6.564c0,2.477,0.949,4.667,2.855,6.57l14.274,14.271c1.903,1.905,4.093,2.854,6.567,2.854 c2.473,0,4.663-0.951,6.567-2.854l133.042-133.044c1.902-1.902,2.854-4.093,2.854-6.567S224.603,137.807,222.701,135.9z"/></g></svg></button>'
          })
        },
        unmatch: function(){        
        }
      })

      $(".product-image__featured-image-next").click(function(){
        var $order = $(".product-image__thumbnail-image .slick-current").attr("data-slick-index");
        var $next = parseInt($order) + 1
        var $nextSlide = $(".product-image__thumbnail-image .slick-slide[data-slick-index='" + $next  + "']")
        if ( $nextSlide.length > 0 ){
          $nextSlide.trigger("click")
        }
        else{
          $(".product-image__thumbnail-image .slick-slide[data-slick-index='0']").trigger("click")
        }
      })

      var biggestOrderNumber = 0;
      $(".product-image__thumbnail-image .slick-slide:not(.slick-cloned)").each(function(){
        var $index = $(this).attr("data-slick-index")
        if ($index > biggestOrderNumber){
          biggestOrderNumber = $index;
        }
      })

      $(".product-image__featured-image-prev").click(function(){
        var $order = $(".product-image__thumbnail-image .slick-current").attr("data-slick-index");
        var $prev = parseInt($order) - 1
        var $prevSlide = $(".product-image__thumbnail-image .slick-slide[data-slick-index='" + $prev  + "']")
        if ( $prevSlide.length > 0 ){
          $prevSlide.trigger("click")
        }
        else{
          $(".product-image__thumbnail-image .slick-slide[data-slick-index='" + biggestOrderNumber  + "']").trigger("click")
        }
      })
    },
    filterImage: function(e){
      var inputLength = $("[data-swatch-input]").length;
      if ( inputLength > 1 ){
        var $selectedVal = $("[data-swatch-input]:checked").attr("data-val");

        $(".featured-image__zoom").filter(function(i, element){
          return $(element).attr("data-alt") == $selectedVal || $(element).attr("data-alt") == "global"
        })

        $(".product-image__thumbnail-image").slick("slickUnfilter")
        $(".product-image__thumbnail-image").slick("slickFilter", function(i, element){
          console.log($(element).attr("data-alt"), $selectedVal, "each -------")
          return $(element).attr("data-alt") == $selectedVal || $(element).attr("data-alt") == "global"
        })

        // Reset Original Index so no duplicates
        var $slides = $(".product-image__thumbnail-image").find('.slick-slide:not(.slick-cloned)');
        $(".featured-image__zoom-image").each(function(){
          var originalIndex = $(this).attr("data-original-zoom-index")
          $(".featured-image__zoom-image").attr("data-order", originalIndex)
        })
        // Changing Index to Correct Indexes
        $slides.each(function (i) {
          var originalIndex = $(this).attr("data-original-thumbnail-index")
          var indexPlusOne = i + 1
          $(".featured-image__zoom-image[data-order='"+indexPlusOne+"']").attr("data-order", originalIndex)
          $(".featured-image__zoom-image[data-original-zoom-index='"+originalIndex+"']").attr("data-order", indexPlusOne)
          $(this).attr('data-slick-index', i);
        })

        $(".product-image__thumbnail-image").slick('slickGoTo', 0, true)

      }
    },
    featuredZoomImage: function(evt){
      $(".product-image__thumbnail-image").on("afterChange", function(event, slick, currentSlide, nextSlide){
        loadZoomImage()
      })
      $(document).ready(function(){
        loadZoomImage();
      })
      function loadZoomImage(){
        var $index = parseInt($(".product-image__thumbnail-image .slick-current").attr("data-slick-index")) + 1;
        $(".featured-image__zoom-image").removeClass("active");
        $(".featured-image__zoom-image[data-order='" + $index + "']").addClass("active");
      }

      $('.featured-image__zoom')
      .on('mouseover', function(){
        $(this).children('.featured-image__zoom-image.active').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
      })
      .on('mouseout', function(){
        $(this).children('.featured-image__zoom-image.active').css({'transform': 'scale(1)'});
      })
      .on('mousemove', function(e){
        $(this).children('.featured-image__zoom-image.active').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
      })
    },
    
    reviews: function(e){
      
        // Observe Product Reviews wrapper for mutations
      var targetNode = document.getElementById('shopify-product-reviews');

      // Define which mutations to observe
      var config = { childList: true, subtree: true };

      // Execute this when mutations are observed
      var callback = function() {
        $(".spr-summary-actions-newreview").before("<p class='product-reviews__share-text'>Share your thoughts with other customers</p>")
        var $clippedReviewText = $(".spr-summary-actions-togglereviews").text().replace("Based on", "")  
        $(".spr-summary-actions-togglereviews").text($clippedReviewText)
        if ( $(".spr-review").length > 1 ){
          $(".product-reviews").append("<button class='product-reviews__show-more'>SHOW MORE REVIEWS</button>")
        }
        $(".spr-pagination").hide();
        $(".spr-review:not(:first-child)").hide();
        $(".spr-review:first-child .spr-review-content").addClass("no-margin");
        $(".spr-review-header-byline").prepend("<strong>By </strong>")

        // [INJECT HTML HERE]

          // Stop observing
          observer.disconnect();
      };

      // Create an observer instance linked to the callback function
      var observer = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      if (targetNode !== null) observer.observe(targetNode, config);

      $("body").on("click", ".product-reviews__show-more", function(){
        var $el = $(this);
        $(".spr-review").each(function(){
          $(this).show()
          $el.hide();
          $(".spr-pagination").show();
          $(".spr-review:first-child .spr-review-content").removeClass("no-margin");
        })
      })
    },
    
    bundleProducts: function(e){

      $(".product-card__qty--input").change(function(){
        var $this = $(this);
        var totalQuantity = 0;  

        $(".product-card__qty--input").each(function(){
          totalQuantity = totalQuantity + parseInt($(this).val());
        })

        if (totalQuantity > 3 ){
          $this.val(0)
          alert("Sorry, 3 Items Max!")
        }
      })

      
      $(".product-card__qty-adjust--plus").click(function(){
        var totalQuantity = 0;  
        var $parent = $(this).parent(".product-card__qty");
        var $input = $parent.find(".product-card__qty--input");
        var $currentVal = parseInt($input.val());
        $input.val($currentVal + 1)

        $(".product-card__qty--input").each(function(){
          totalQuantity = totalQuantity + parseInt($(this).val());
        })
        
        if (totalQuantity > 3 ){
          $input.val(parseInt($currentVal))
          totalQuantity = totalQuantity - 1;
          alert("Sorry, 3 Items Max!")
        }
      })


      $(".product-card__qty-adjust--minus").click(function(){
        var $input = $(this).next(".product-card__qty--input");
        var $currentVal = parseInt($input.val());
        if ( $currentVal > 0 ){
          $input.val($currentVal - 1)
        }
      })
            

      $(".product-bundle__products-add").click(function(){
        var property = {
          'Custom': 'Custom 3-Pack'
        }
        Shopify.queue = [];
        $(".product-card__qty--input").each(function(){
          if ( $(this).val() > 0 ){
            var $variantId = $(this).attr("data-variant-id");
            var $quantity = $(this).val();
            // console.log( $variantId , $quantity , "---" )
            Shopify.queue.push({
              quantity: $quantity,
              id: $variantId,
              properties: property
            })
          }
        })
           
        
        Shopify.queue = Shopify.queue.reverse();
        if (Shopify.queue.length > 0 ){
          Shopify.moveAlong = function(){
            if(Shopify.queue.length) {
              var data = Shopify.queue.shift();
              // console.log(data)
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: data,
                success: function(res) {
                  // console.log("success")
                  Shopify.moveAlong();
                },
                error: function(){
                  if (Shopify.queue.length) {
                    Shopify.moveAlong();
                  }else{
                    ajaxCart.load();
                  }
                }
              })
            }else{
              $(".product-card__qty--input").each(function(){
                $(this).val(0);
              })
              ajaxCart.load();
            }
          }
          Shopify.moveAlong()  
        }
      })
         
      
      //---------------custom 5 pack----------------------
      
      $(".product-card__qty--input-5-pack").change(function(){
        var $this = $(this);
        var totalQuantity = 0;  

        $(".product-card__qty--input-5-pack").each(function(){
          totalQuantity = totalQuantity + parseInt($(this).val());
        })

        if (totalQuantity > 5 ){
          $this.val(0)
          alert("Sorry, 5 Items Max!")
        }
      })
      
      $(".product-card__qty-adjust--plus-5-pack").click(function(){
        var totalQuantity = 0;  
        var $parent = $(this).parent(".product-card__qty");
        var $input = $parent.find(".product-card__qty--input-5-pack");
        var $currentVal = parseInt($input.val());
        
        $input.val($currentVal + 1)

        $(".product-card__qty--input-5-pack").each(function(){
          totalQuantity = totalQuantity + parseInt($(this).val());
        })
        
        if (totalQuantity > 5 ){
          $input.val(parseInt($currentVal))
          totalQuantity = totalQuantity - 1;
          alert("Sorry, 5 Items Max!")
        }
      })


      $(".product-card__qty-adjust--minus-5-pack").click(function(){
        var $input = $(this).next(".product-card__qty--input-5-pack");
        var $currentVal = parseInt($input.val());
        if ( $currentVal > 0 ){
          $input.val($currentVal - 1)
        }
      })
      
      $(".product-bundle__products-add-5-pack").click(function(){
        var property = {
          'Custom': 'Custom 5-Pack'
        }
        Shopify.queue = [];
        $(".product-card__qty--input-5-pack").each(function(){
          if ( $(this).val() > 0 ){
            var $variantId = $(this).attr("data-variant-id");
            var $quantity = $(this).val();
            // console.log( $variantId , $quantity , "---" )
            Shopify.queue.push({
              quantity: $quantity,
              id: $variantId,
              properties: property
            })
          }
        })
           
        
        Shopify.queue = Shopify.queue.reverse();
        if (Shopify.queue.length > 0 ){
          Shopify.moveAlong = function(){
            if(Shopify.queue.length) {
              var data = Shopify.queue.shift();
              // console.log(data)
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: data,
                success: function(res) {
                  // console.log("success")
                  Shopify.moveAlong();
                },
                error: function(){
                  if (Shopify.queue.length) {
                    Shopify.moveAlong();
                  }else{
                    ajaxCart.load();
                  }
                }
              })
            }else{
              $(".product-card__qty--input-5-pack").each(function(){
                $(this).val(0);
              })
              ajaxCart.load();
            }
          }
          Shopify.moveAlong()  
        }
      })
      
	  //----------------end custom 5 pack--------------------

    //---------------new custom 3 pack----------------------
      
    $(".product-card__qty--input-3-pack").change(function(){
      var $this = $(this);
      var totalQuantity = 0;  

      $(".product-card__qty--input-3-pack").each(function(){
        totalQuantity = totalQuantity + parseInt($(this).val());
      })

      if (totalQuantity > 3 ){
        $this.val(0)
        alert("Sorry, 3 Items Max!")
      }
    })
    
    $(".product-card__qty-adjust--plus-3-pack").click(function(){
      var totalQuantity = 0;  
      var $parent = $(this).parent(".product-card__qty");
      var $input = $parent.find(".product-card__qty--input-3-pack");
      var $currentVal = parseInt($input.val());
      
      $input.val($currentVal + 1)

      $(".product-card__qty--input-3-pack").each(function(){
        totalQuantity = totalQuantity + parseInt($(this).val());
      })
      
      if (totalQuantity > 3 ){
        $input.val(parseInt($currentVal))
        totalQuantity = totalQuantity - 1;
        alert("Sorry, 3 Items Max!")
      } else {
        const productCard = $(this).parents('.product-card');
        const productId = productCard.attr('data-product-id');
        const productCardImage = productCard.attr('data-featured-image');
        const productCardProductTitle = productCard.attr('data-product-title');
        const bundleContainer = $('.custom-bundle__container');
        const bundleCurrentSlots = parseInt(bundleContainer.attr('data-current-slots'));
        const destinatedSlot = bundleCurrentSlots + 1;
        const bundleSlot = $(`.custom-bundle__slot:not('.added')`).first();
        
        const tempCard = 
        `<div class="product-card">
            <div class="product-card__image-container">
                <div class="product-card__image">
                    <img src="${productCardImage}" alt>
                </div>
            </div>
            <div class="product-card__title-and-review">
                <p class="product-card__title">${productCardProductTitle}</p>
            </div>
        </div>`
        bundleSlot.append(tempCard);
        bundleSlot.attr('data-product-id', productId);
        bundleSlot.addClass('added');
        bundleContainer.attr("data-current-slots", destinatedSlot);
      }
    })

    $(".product-card__qty-adjust--minus-3-pack").click(function(){
      var $input = $(this).next(".product-card__qty--input-3-pack");
      var $currentVal = parseInt($input.val());
      if ( $currentVal > 0 ){
        $input.val($currentVal - 1);
        const productCard = $(this).parents('.product-card');
        const productId = productCard.attr('data-product-id');
        const bundleContainer = $('.custom-bundle__container');
        const bundleCurrentSlots = parseInt(bundleContainer.attr('data-current-slots'));
        const bundleSlot = bundleContainer.find(`.custom-bundle__slot[data-product-id="${productId}"]`).last();
        bundleSlot.empty();
        bundleSlot.attr('data-product-id', "");
        bundleSlot.appendTo(bundleContainer);
        bundleSlot.removeClass('added');
        bundleContainer.attr("data-current-slots", bundleCurrentSlots - 1);
      }
    })
    
    $(".product-bundle__products-add-3-pack").click(function(){
      const bundleContainer = $('.custom-bundle__container');
      const bundleCurrentSlots = parseInt(bundleContainer.attr('data-current-slots'));

      if (bundleCurrentSlots < 3) {
        alert("Sorry, please make sure to select 3 items!");
      } else {
        const bundleType = $('.bundle-builder').attr('data-bundle-type');
        var property = {
          'Custom': bundleType
        }
        Shopify.queue = [];
        $(".product-card__qty--input-3-pack").each(function(){
          if ( $(this).val() > 0 ){
            var $variantId = $(this).attr("data-variant-id");
            var $quantity = $(this).val();
            // console.log( $variantId , $quantity , "---" )
            Shopify.queue.push({
              quantity: $quantity,
              id: $variantId,
              properties: property
            })
          }
        })
           
        
        Shopify.queue = Shopify.queue.reverse();
        if (Shopify.queue.length > 0 ){
          Shopify.moveAlong = function(){
            if(Shopify.queue.length) {
              var data = Shopify.queue.shift();
              // console.log(data)
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: data,
                success: function(res) {
                  // console.log("success")
                  Shopify.moveAlong();
                },
                error: function(){
                  if (Shopify.queue.length) {
                    Shopify.moveAlong();
                  }else{
                    ajaxCart.load();
                  }
                }
              })
            }else{
              $(".product-card__qty--input-3-pack:not('.required')").each(function(){
                $(this).val(0);
              })
              ajaxCart.load();

              const bundleContainer = $('.custom-bundle__container');
              const requiredSlot = bundleContainer.find(`.custom-bundle__slot.required`);
              const bundleSlots = bundleContainer.find(`.custom-bundle__slot:not('.required')`);
              bundleSlots.each(function(){
                $(this).empty();
                $(this).removeClass('added');
                $(this).attr('data-product-id', "");
              })
              bundleContainer.attr("data-current-slots", (requiredSlot.length) ? requiredSlot.length : 0);
            }
          }
          Shopify.moveAlong()  
        } 
      }
    })

    //----------------end new custom 3 pack--------------------

    //---------------new custom 5 pack----------------------
      
    $(".product-card__qty--input-5-pack-new").change(function(){
      var $this = $(this);
      var totalQuantity = 0;  

      $(".product-card__qty--input-5-pack-new").each(function(){
        totalQuantity = totalQuantity + parseInt($(this).val());
      })

      if (totalQuantity > 5 ){
        $this.val(0)
        alert("Sorry, 5 Items Max!")
      }
    })
    
    $(".product-card__qty-adjust--plus-5-pack-new").click(function(){
      var totalQuantity = 0;  
      var $parent = $(this).parent(".product-card__qty");
      var $input = $parent.find(".product-card__qty--input-5-pack-new");
      var $currentVal = parseInt($input.val());
      
      $input.val($currentVal + 1)

      $(".product-card__qty--input-5-pack-new").each(function(){
        totalQuantity = totalQuantity + parseInt($(this).val());
      })
      
      if (totalQuantity > 5 ){
        $input.val(parseInt($currentVal))
        totalQuantity = totalQuantity - 1;
        alert("Sorry, 5 Items Max!")
      } else {
        const productCard = $(this).parents('.product-card');
        const productId = productCard.attr('data-product-id');
        const productCardImage = productCard.attr('data-featured-image');
        const productCardProductTitle = productCard.attr('data-product-title');
        const bundleContainer = $('.custom-bundle__container');
        const bundleCurrentSlots = parseInt(bundleContainer.attr('data-current-slots'));
        const destinatedSlot = bundleCurrentSlots + 1;
        const bundleSlot = $(`.custom-bundle__slot:not('.added')`).first();
        const tempCard = 
        `<div class="product-card">
            <div class="product-card__image-container">
                <div class="product-card__image">
                    <img src="${productCardImage}">
                </div>
            </div>
            <div class="product-card__title-and-review">
                <p class="product-card__title">${productCardProductTitle}</p>
            </div>
        </div>`
        bundleSlot.append(tempCard);
        bundleSlot.attr('data-product-id', productId);
        bundleSlot.addClass('added');
        bundleContainer.attr("data-current-slots", destinatedSlot);
      }
    })

    $(".product-card__qty-adjust--minus-5-pack-new").click(function(){
      var $input = $(this).next(".product-card__qty--input-5-pack-new");
      var $currentVal = parseInt($input.val());
      if ( $currentVal > 0 ){
        $input.val($currentVal - 1);
        const productCard = $(this).parents('.product-card');
        const productId = productCard.attr('data-product-id');
        const bundleContainer = $('.custom-bundle__container');
        const bundleCurrentSlots = parseInt(bundleContainer.attr('data-current-slots'));
        const bundleSlot = bundleContainer.find(`.custom-bundle__slot[data-product-id="${productId}"]`).last();
        bundleSlot.empty();
        bundleSlot.attr('data-product-id', "");
        bundleSlot.appendTo(bundleContainer);
        bundleSlot.removeClass('added');
        bundleContainer.attr("data-current-slots", bundleCurrentSlots - 1);
      }
    })
    
    $(".product-bundle__products-add-5-pack-new").click(function(){
      const bundleContainer = $('.custom-bundle__container');
      const bundleCurrentSlots = parseInt(bundleContainer.attr('data-current-slots'));

      if (bundleCurrentSlots < 5) {
        alert("Sorry, please make sure to select 5 items!");
      } else {
        var property = {
          'Custom': 'Custom 5-Pack'
        }
        Shopify.queue = [];
        $(".product-card__qty--input-5-pack-new").each(function(){
          if ( $(this).val() > 0 ){
            var $variantId = $(this).attr("data-variant-id");
            var $quantity = $(this).val();
            // console.log( $variantId , $quantity , "---" )
            Shopify.queue.push({
              quantity: $quantity,
              id: $variantId,
              properties: property
            })
          }
        })
           
        
        Shopify.queue = Shopify.queue.reverse();
        if (Shopify.queue.length > 0 ){
          Shopify.moveAlong = function(){
            if(Shopify.queue.length) {
              var data = Shopify.queue.shift();
              // console.log(data)
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: data,
                success: function(res) {
                  // console.log("success")
                  Shopify.moveAlong();
                },
                error: function(){
                  if (Shopify.queue.length) {
                    Shopify.moveAlong();
                  }else{
                    ajaxCart.load();
                  }
                }
              })
            }else{
              $(".product-card__qty--input-5-pack-new:not('.required')").each(function(){
                $(this).val(0);
              })
              ajaxCart.load();

              const bundleContainer = $('.custom-bundle__container');
              const requiredSlot = bundleContainer.find(`.custom-bundle__slot.required`);
              const bundleSlots = bundleContainer.find(`.custom-bundle__slot:not('.required')`);
              bundleSlots.each(function(){
                $(this).empty();
                $(this).removeClass('added');
                $(this).attr('data-product-id', "");
              })
              bundleContainer.attr("data-current-slots", (requiredSlot.length) ? requiredSlot.length : 0);
            }
          }
          Shopify.moveAlong()  
        } 
      }
    })
  //----------------end new custom 5 pack--------------------
    
    },

    bundleProducts2: function(e){

      $(".product-card__qty--input").change(function(){
        var $this = $(this);
        var totalQuantity = 0;  

        $(".product-card__qty--input").each(function(){
          totalQuantity = totalQuantity + parseInt($(this).val());
        })
      })

      
      $(".product-card__qty-adjust--plus").click(function(){
        var totalQuantity = 0;  
        var $parent = $(this).parent(".product-card__qty");
        var $input = $parent.find(".product-card__qty--input");
        var $currentVal = parseInt($input.val());
        $input.val($currentVal + 1)

        $(".product-card__qty--input").each(function(){
          totalQuantity = totalQuantity + parseInt($(this).val());
        })
      })


      $(".product-card__qty-adjust--minus").click(function(){
        var $input = $(this).next(".product-card__qty--input");
        var $currentVal = parseInt($input.val());
        if ( $currentVal > 0 ){
          $input.val($currentVal - 1)
        }
      })

      $(".product-bundle__products-add").click(function(){
        Shopify.queue = [];
        $(".product-card__qty--input").each(function(){
          if ( $(this).val() > 0 ){
            var $variantId = $(this).attr("data-variant-id");
            var $quantity = $(this).val();
            // console.log( $variantId , $quantity , "---" )
            Shopify.queue.push({
              quantity: $quantity,
              id: $variantId,
            })
          }
        })
        Shopify.queue = Shopify.queue.reverse();
        if (Shopify.queue.length > 0 ){
          Shopify.moveAlong = function(){
            if(Shopify.queue.length) {
              var data = Shopify.queue.shift();
              // console.log(data)
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: data,
                success: function(res) {
                  // console.log("success")
                  Shopify.moveAlong();
                },
                error: function(){
                  if (Shopify.queue.length) {
                    Shopify.moveAlong();
                  }else{
                    ajaxCart.load();
                  }
                }
              })
            }else{
              $(".product-card__qty--input").each(function(){
                $(this).val(0);
              })
              ajaxCart.load();
            }
          }
          Shopify.moveAlong()  
        }
      })

    },      
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.Collection = (function() {

    function Collection(container) {

        var selectedValue

        // Close Drawer 
        $("body").on("change", ".filter-sort__visual", function(){
            $(".nav-sort-orders a[data-filter-value='" + $(this).val() + "']").trigger("click");        
        })

        
    
        var resizeWindow;
        var filterJustOpened = false;
        $(window).on('resize', function(e) {
            clearTimeout(resizeWindow);
            resizeWindow = setTimeout(function() {
              if (!filterJustOpened) {
                $(".collection-content__collection-filters, .template-collection").removeClass("active");  
              }
            }, 250);
        });
        
        // Collection Filter ====
        $("body").on("click", ".collection-content__filter-trigger, .pt-apply--close", function(e){
            e.preventDefault();
            $(".filter-menu").addClass("pt-expand")
            if ( $(".collection-content__collection-filters").hasClass("active") ){
                $(".collection-content__collection-filters").removeClass("active");
                $(".template-collection").removeClass("active");
    
            }
            else{
                clearTimeout(resizeWindow);
                filterJustOpened = true;
                $(".collection-content__collection-filters").addClass("active");
                $(".template-collection").addClass("active");
                setTimeout(function() {
                  filterJustOpened = false;
                }, 5000);
            }
        });

        /*enquire.register("screen and (max-width: 767px)", {
          match : function() {
            $('body').on('click', '.collection-container.active a', function(e){
              e.preventDefault();
              if (sessionStorage.getItem('filterOptionSelected') === null) {
                sessionStorage.setItem('filterOptionSelected', true);
              }
    
              window.location.href = $(this).attr('href');
            })
          },
          unmatch : function() {
            $("body").off('click', '.collection-container.active a');
          }
        });*/
    }
  
    return Collection;
})();

  











$("body").on("click", "[data-quick-add]", function(evt){
    var $currentTarget = $(this);
    evt.preventDefault();
    addProduct($currentTarget);
})
function addProduct($currentTarget){
    var $variantId = $currentTarget.attr("data-variant-id")
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data:  'quantity=1&id=' + $variantId,
        id: $variantId,
        quantity: 1,
        error: function(){
            console.log("error")
        },
        success: function(){
            ajaxCart.load();
        }
    })
}
/**
 * RelatedProducts Section Script
 * Shopify Plus Only - https://help.shopify.com/en/themes/development/recommended-products
 * ------------------------------------------------------------------------------
 *
   * @namespace relatedProducts
 */

theme.RelatedProducts = (function() {
    var selectors = {
      sectionSettingsJson: '[data-settings-json]',
      template: '#RelatedProductsTemplate-',
      relatedProductsContainer: '#RelatedProducts-'
    };
  
    /**
     * RelatedProducts section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function RelatedProducts(container) {
      this.$container = $(container);
  
      var sectionId = this.sectionId = this.$container.attr('data-section-id');
      var sectionSettings = JSON.parse($(selectors.sectionSettingsJson, this.$container).html());
  
      this.settings = sectionSettings;
      this.namespace = '.relatedProducts';
  
      // Selectors
      this.$shopifySection = $('#shopify-section-' + this.sectionId);
      this.$template = $(selectors.template + sectionId, this.$container);
      this.$relatedProductsContainer = $(selectors.relatedProductsContainer + sectionId, this.$container);
      this.getProducts();
    }
  
    RelatedProducts.prototype = $.extend({}, RelatedProducts.prototype, {
  
      /**
       * Go get products via ajax
       */
      getProducts: function() {
        var url = "/recommendations/products.json?product_id=" + this.settings.id + "&limit=" + this.settings.limit;
        var self= this;
  
        $.ajax({
          type: 'GET',
          url: url,
          dataType: 'json'
        })
        .done(this.getProductsSuccess.bind(this))
        .fail(this.getProductsError.bind(this));
      },
  
      /**
       * Build product cards with Handlebars
       *
       * @param {object} results - Data sent back from Shopify
       * @param {array} results.products - Array of related products
       */
      getProductsSuccess: function(results) {
        if (results.products.length === 0) {
          return;
        }
  
        var products = results.products;
        var data = {};
        var item = {};
        var items = [];
        var source = this.$template.html();
        var template = Handlebars.compile(source);
        // Build items array
        $.each(products, function(index, product){
          item = {
            id: product.id,
            available: product.available,
            url: product.url,
            title: product.title,
            tags: product.tags,
            image_1:  product.images[0],
            variant: product.variants,
            variant_id: product.variants[0].id,
            compare_at_price: slate.Currency.formatMoney(product.compare_at_price),
            price: slate.Currency.formatMoney(product.price),
            available: product.available
          };

          if ( $.inArray("new", product.tags) > -1 ){
            item.new = true;
          }
          else{
            item.new = false;
          }
          
          if ( product.available == true ){
            item.available = true;
          }
          else{
            item.available = false;
          }
          var productTitle = product.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
          if ( productTitle.indexOf("custom-3-pack") > 0 ){
            item.showQuickAdd = false;
          }
          else{
            item.showQuickAdd = true;
          }

          if (product.compare_at_price > product.price){
            item.sale = true;
            item.percentage = Math.floor((( product.compare_at_price - product.price ) * 100 ) / product.compare_at_price ) + "% off";
          }
          else{
            item.sale = false;
          }

          if ( product.images[1] === undefined){
            item.image_2_availability = false;
          }
          else{
            item.image_2 = product.images[1]
            item.image_2_availability = true;
          }


          items.push(item);
        });
  
        data = {
          items: items
        };

        // Show section and load products
        this.$shopifySection.removeClass('hide');
        this.$relatedProductsContainer.append(template(data));
        this.slickRelatedProducts();
        this.productCardChanges();
      },
  
      /**
       * Log any errors
       */
      getProductsError: function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus + ': ' + errorThrown);
      },
      slickRelatedProducts: function(e){
        enquire.register(theme.config.mediaQueries.largeUp,{
            match: function(){
                if( $(".related-products").hasClass("slick-initialized") ){
                    $(".related-products").slick("unslick");
                }
            },
            unmatch: function(){
            }
            
        }).register(theme.config.mediaQueries.smallDown, {
            match: function(){
                if( $(".related-products").hasClass("slick-initialized") ){
                    $(".related-products").slick("unslick");
                }
                $(".related-products").slick({
                    slidesToShow: 1,
                    slidestoScroll: 1,
                    arrows: false,
                    dots: false
                })
            },
            unmatch: function(){        
            }
        }).register(theme.config.mediaQueries.medium, {
            match: function(){
                if( $(".related-products").hasClass("slick-initialized") ){
                    $(".related-products").slick("unslick");
                }
                $(".related-products").slick({
                    slidesToShow: 3,
                    slidestoScroll: 1,
                    arrows: false,
                    dots: false
                })
            },
            unmatch: function(){        
            }
        })
      },
      productCardChanges: function(e){
        $("body").on("click", "[data-quick-add]", function(evt){
          var $currentTarget = $(this);
          evt.preventDefault();
          addProduct($currentTarget);
        })
        function addProduct($currentTarget){
          var $variantId = $currentTarget.attr("data-variant-id")
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data:  'quantity=1&id=' + $variantId,
            id: $variantId,
            quantity: 1,
            error: function(){
                console.log("error")
            },
            success: function(){
                ajaxCart.load();
            }
          })
        }
      },
      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onUnload: function() {
        this.$container.off(this.namespace);
      }
    });
  
    return RelatedProducts;
})();
theme.HomeSlider = (function(){

    const item_slider_time = $('.homepage-hero__container .homepage-hero.item_timer');
    const now = new Date(new Date().toLocaleString("en-US", {timeZone: "America/Los_Angeles"}));
  
  	function formatDate (time) {

        var dateStr, timeStr;
      	const arrDay = time.split(' ');
      
        for ( const i in arrDay ) {
          if (i==0) {
            dateStr = arrDay[i];
          } else {
           	timeStr = arrDay[i];
          }
        }
      	
      	const dateArrOgirinal = dateStr.split('-');
      	const dateArr = [];
      	dateArr[0] = dateArrOgirinal[2];
      	dateArr[1] = dateArrOgirinal[0];
      	dateArr[2] = dateArrOgirinal[1];

      	const timeArr = timeStr.split(':');
      
      	var datetimeArr = dateArr.concat(timeArr);
      
      	return `${datetimeArr[0]}-${datetimeArr[1]}-${datetimeArr[2]}T${datetimeArr[3]}:${datetimeArr[4]}:${datetimeArr[5]}`;

    }
  
    item_slider_time.each(function(i){
      
      const checkStart = $(this).attr('data-start_time');
      const checkEnd = $(this).attr('data-end_time');
      
      
      if(checkStart !== undefined && checkEnd !== undefined) {
        const start_timer  = new Date(formatDate(checkStart));
        const end_timer = new Date(formatDate(checkEnd));
        if( start_timer.getTime() <= now.getTime() && now.getTime() <= end_timer.getTime()){
        	$(this).addClass('slider-show');
        }
      }
  	  else if(checkStart !== undefined && checkEnd === undefined){
        const start_timer  = new Date(formatDate(checkStart));
        if( start_timer.getTime() <= now.getTime() ){
        	$(this).addClass('slider-show');
        } 
      }
      else if(checkStart === undefined && checkEnd !== undefined){
        const end_timer = new Date(formatDate(checkEnd));
        if( end_timer.getTime() > now.getTime() ){
        	$(this).addClass('slider-show');
        }
      }

    });
  
    function HomeSlider(container){
        var $autoplay = $("[js-home-slider-slick]").attr("js-autoplay");
        if ($autoplay == 'false' ){
            $autoplay = false
        }
        else{
            $autoplay = true
        }
        var $autoplaySpeed = $("[js-home-slider-slick]").attr("js-autoplay-speed") * 1000;
        $("[js-home-slider-slick]").slick({
            rows: 0,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            adaptiveHeight: true,
            autoplay: $autoplay,
            autoplaySpeed: $autoplaySpeed,
            prevArrow: '<button class="product-image__thumbnail-image-prev" aria-label="Previous"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="284.935px" height="284.936px" viewBox="0 0 284.935 284.936" style="enable-background:new 0 0 284.935 284.936;" xml:space="preserve"><g><path d="M110.488,142.468L222.694,30.264c1.902-1.903,2.854-4.093,2.854-6.567c0-2.474-0.951-4.664-2.854-6.563L208.417,2.857 C206.513,0.955,204.324,0,201.856,0c-2.475,0-4.664,0.955-6.567,2.857L62.24,135.9c-1.903,1.903-2.852,4.093-2.852,6.567 c0,2.475,0.949,4.664,2.852,6.567l133.042,133.043c1.906,1.906,4.097,2.857,6.571,2.857c2.471,0,4.66-0.951,6.563-2.857 l14.277-14.267c1.902-1.903,2.851-4.094,2.851-6.57c0-2.472-0.948-4.661-2.851-6.564L110.488,142.468z"/></g></svg></button>',
            nextArrow: '<button class="product-image__thumbnail-image-next" aria-label="Next"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="284.935px" height="284.936px" viewBox="0 0 284.935 284.936" style="enable-background:new 0 0 284.935 284.936;" xml:space="preserve"><g><path d="M222.701,135.9L89.652,2.857C87.748,0.955,85.557,0,83.084,0c-2.474,0-4.664,0.955-6.567,2.857L62.244,17.133 c-1.906,1.903-2.855,4.089-2.855,6.567c0,2.478,0.949,4.664,2.855,6.567l112.204,112.204L62.244,254.677 c-1.906,1.903-2.855,4.093-2.855,6.564c0,2.477,0.949,4.667,2.855,6.57l14.274,14.271c1.903,1.905,4.093,2.854,6.567,2.854 c2.473,0,4.663-0.951,6.567-2.854l133.042-133.044c1.902-1.902,2.854-4.093,2.854-6.567S224.603,137.807,222.701,135.9z"/></g></svg></button>'
        })
        
        $("[js-home-slider-slick]").slick('slickFilter','.slider-show');
      
    }
    return HomeSlider;
})();

theme.HomeFeaturedCollection = (function() {
   
    function HomeFeaturedCollection(container) {
        enquire.register(theme.config.mediaQueries.largeUp,{
            match: function(){
                if( $("[js-featuerd-collection]").hasClass("slick-initialized") ){
                    $("[js-featuerd-collection]").slick("unslick");
                }
            },
            unmatch: function(){
            }

        }).register(theme.config.mediaQueries.smallDown, {
            match: function(){
                if( $("[js-featuerd-collection]").hasClass("slick-initialized") ){
                    $("[js-featuerd-collection]").slick("unslick");
                }
                $("[js-featuerd-collection]").slick({
                    slidesToShow: 1,
                    slidestoScroll: 1,
                    arrows: false,
                    dots: false
                })
            },
            unmatch: function(){        
            }
        }).register(theme.config.mediaQueries.medium, {
            match: function(){
                if( $("[js-featuerd-collection]").hasClass("slick-initialized") ){
                    $("[js-featuerd-collection]").slick("unslick");
                }
                $("[js-featuerd-collection]").slick({
                    slidesToShow: 3,
                    slidestoScroll: 1,
                    arrows: false,
                    dots: false
                })
            },
            unmatch: function(){        
            }
        }) 
    }

    return HomeFeaturedCollection;
})();

theme.CollabVideo = (function(){
    var selectors = {
        video: '[js-video]',
        overlay: '[js-video-overlay]'
    }

    function CollabVideo(container) {
        this.$container = $(container);
        var $video = $(selectors.video, this.$container);
        var $overlay = $(selectors.overlay, this.$container);

        $video[0].addEventListener("playing", function() {
            $overlay.hide();
        })

        $video[0].addEventListener("ended", function() {
            $overlay.show();
        })

        $video[0].addEventListener("pause", function() {
            $overlay.show();
        })

        $video.on('click', function(){
            if($video[0].paused) {
                $video[0].play();
                $overlay.hide();
            } else {
                $video[0].pause();
                $overlay.show();
            }
        })

        $overlay.on('click', function(){
            if($video[0].paused) {
                $video[0].play();
                $overlay.hide();
            } else {
                $video[0].pause();
                $overlay.show();
            }
        })

    }

    return CollabVideo
})()
/**
* Swatches Script
* ------------------------------------------------------------------------------
*/

theme.swatches = (function() {
    if (!$('.swatch').length) {
      return;
    }
   
    var $swatchInput = $('[data-swatch-input]');
    var namespace = '.swatch';
   
    $swatchInput.on('change' + namespace, updateSingleOptionSelector);
   
    function updateSingleOptionSelector(evt) {
      var $el = $(evt.currentTarget);
      var optionIndex = $el.closest('.swatch').attr('data-option-index');
      var optionValue = $el.val();
   
      $el.closest('form')
        .find('[data-single-option-selector]')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
    }

    // Selecting Correct Swatch on load
    $(".selector-wrapper").each(function(){
      var $selected = $(this).find("select option:selected").val()
      $(".swatch-element[data-value='" + $selected + "'] input").prop("checked", true)
    })

})();
   
theme.missionSlick = (function(){
    var selectors = {
        slickContainer: '[js-mission-slick]'
    }

    function missionSlick(container) {
        this.$container = $(container);
        var $mission = $(selectors.slickContainer, this.$container);

        

        enquire.register(theme.config.mediaQueries.largeUp, {
            match: function() {
                if($mission.hasClass('slick-initialized')) {
                    $mission.slick('unslick');
                } 
            
            }
        })
        enquire.register(theme.config.mediaQueries.mediumDown, {
            match: function() {
                if($mission.hasClass('slick-initialized')) {
                    $mission.slick('unslick');
                } 

                $mission.slick({
                    arrows: false,
                    dots: true
                })
            }
        })
    }

    return missionSlick
})()
theme.aboutSlider = (function(){
    var selectors = {
        slickContainer: '[js-about-slick]'
    }

    function aboutSlider(container) {
        this.$container = $(container);
        var $aboutSlider = $(selectors.slickContainer, this.$container);

        enquire.register(theme.config.mediaQueries.largeUp, {
            match: function() {
                if($aboutSlider.hasClass('slick-initialized')) {
                    $aboutSlider.slick('unslick');
                }

                $aboutSlider.slick({
                    arrows: true,
                    dots: true,
                    prevArrow: '<button class="slick-prev slick-arrow"> <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46"> <g fill="none" fill-rule="evenodd" transform="translate(1 1)"> <circle cx="22" cy="22" r="22" fill="#FFF" stroke="#E6E6E6" stroke-width="2"/> <path stroke="#C5CFD9" stroke-linecap="round" stroke-width="4" d="M25 14l-8 8.5 8 8.5"/> </g></svg></button>',
                    nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46"> <g fill="none" fill-rule="evenodd" transform="matrix(-1 0 0 1 45 1)"> <circle cx="22" cy="22" r="22" fill="#FFF" stroke="#E6E6E6" stroke-width="2"/> <path stroke="#C5CFD9" stroke-linecap="round" stroke-width="4" d="M25 14l-8 8.5 8 8.5"/> </g></svg></button>'
                })
            
            }
        })

        enquire.register(theme.config.mediaQueries.mediumDown, {
            match: function() {
                if($aboutSlider.hasClass('slick-initialized')) {
                    $aboutSlider.slick('unslick');
                } 

                $aboutSlider.slick({
                    arrows: false,
                    dots: true,
                    prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="54" height="54" viewBox="0 0 54 54"> <defs> <circle id="b" cx="23" cy="23" r="23"/> <filter id="a" width="130.4%" height="130.4%" x="-15.2%" y="-10.9%" filterUnits="objectBoundingBox"> <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/> <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/> <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 1 0"/> </filter> </defs> <g fill="none" fill-rule="evenodd"> <g fill-rule="nonzero" transform="matrix(-1 0 0 1 50 2)"> <use fill="#000" filter="url(#a)" xlink:href="#b"/> <use fill="#FFF" xlink:href="#b"/> </g> <path stroke="#74B819" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M31 35l-8-10 8-10"/> </g></svg></button>',
                    nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="54" height="54" viewBox="0 0 54 54"> <defs> <circle id="b" cx="23" cy="23" r="23"/> <filter id="a" width="130.4%" height="130.4%" x="-15.2%" y="-10.9%" filterUnits="objectBoundingBox"> <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/> <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/> <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 1 0"/> </filter> </defs> <g fill="none" fill-rule="evenodd"> <g fill-rule="nonzero" transform="translate(4 2)"> <use fill="#000" filter="url(#a)" xlink:href="#b"/> <use fill="#FFF" xlink:href="#b"/> </g> <path stroke="#74B819" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M23 35l8-10-8-10"/> </g></svg></button>'
                })
            }
        })
    }

    return aboutSlider
})()
theme.doubleSlider = (function(){
    var selectors = {
        navContainer: '[js-content-slick]',
        sliderContainer: '[js-picture-slick]'
    }

    function doubleSlider(container) {
        this.$container = $(container);
        var $sliderContainer = $(selectors.sliderContainer, this.$container);
        var $navSlider = $(selectors.navContainer, this.$container);


        
        enquire.register(theme.config.mediaQueries.largeUp, {
            match: function() {
                if($sliderContainer.hasClass('slick-initialized')) {
                    $sliderContainer.slick('unslick');
                }
                
                if($navSlider.hasClass('slick-initialized')) {
                    $navSlider.slick('unslick');
                } 
                
                $navSlider.slick({
                    infinite: false,
                    arrows: true,
                    dots: false,
                    asNavFor: '.page-about-double-slider__second-slider'
                })
        
                $sliderContainer.slick({
                    infinite: false,
                    arrows: true,
                    dots: false,
                    asNavFor: '.page-about-double-slider__first-slider',
                    appendArrows: '.page-about-double-slider__buttons',
                    slidesToShow: 1.7,
                    prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46"> <g fill="none" fill-rule="evenodd" transform="translate(1 1)"> <circle cx="22" cy="22" r="22" fill="#FFF" stroke="#E6E6E6" stroke-width="2"/> <path stroke="#C5CFD9" stroke-linecap="round" stroke-width="4" d="M25 14l-8 8.5 8 8.5"/> </g></svg></button>',
                    nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46"> <g fill="none" fill-rule="evenodd" transform="matrix(-1 0 0 1 45 1)"> <circle cx="22" cy="22" r="22" fill="#FFF" stroke="#E6E6E6" stroke-width="2"/> <path stroke="#C5CFD9" stroke-linecap="round" stroke-width="4" d="M25 14l-8 8.5 8 8.5"/> </g></svg></button>'
                })
            }
        })

        enquire.register(theme.config.mediaQueries.mediumDown, {
            match: function() {
                if($sliderContainer.hasClass('slick-initialized')) {
                    $sliderContainer.slick('unslick');
                }

                if($navSlider.hasClass('slick-initialized')) {
                    $navSlider.slick('unslick');
                } 

                $navSlider.slick({
                    infinite: true,
                    arrows: false,
                    dots: true,
                    asNavFor: '.page-about-double-slider__second-slider'
                })
        
                $sliderContainer.slick({
                    infinite: true,
                    arrows: false,
                    dots: false,
                    asNavFor: '.page-about-double-slider__first-slider',
                    slidesToShow: 1
                })
            }
        })
    }

    return doubleSlider
})()
theme.eyeShapeGuide = (function(){

    var config = {
        scrollAndShow: '[js-scroll]',
        scrollAndUpdate: '[js-select]',
        scrollAndHide: '[js-back]'
    }; 

    $(config.scrollAndShow).on('click', scroll);
    $(config.scrollAndUpdate).on('click', select);
    $(config.scrollAndHide).on('click', back);

    if ($('.eye-shape__slick').hasClass('slick-initialized')) {
        $('.eye-shape__slick').slick('unslick');
    } 

    $('.eye-shape__slick').slick({
        infinite: false,
        arrows: true,
        dots: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: '.page-eye-shape-slider__buttons',
        prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46"><g fill="none" fill-rule="evenodd" stroke="#FFF" transform="translate(1 1)"><circle cx="22" cy="22" r="22" fill="#000" stroke-width="2"/><path stroke-linecap="round" stroke-width="4" d="M25 14l-8 8.5 8 8.5"/></g></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46"><g fill="none" fill-rule="evenodd" stroke="#FFF" transform="matrix(-1 0 0 1 45 1)"><circle cx="22" cy="22" r="22" fill="#000" stroke-width="2"/><path stroke-linecap="round" stroke-width="4" d="M25 14l-8 8.5 8 8.5"/></g></svg></button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    })

    function smoothScroll(hash) {
        $('html, body').animate({
            scrollTop: $(hash).offset().top
        }, 600 );
    }

    function back(evt) {
        var hash = this.hash;

        evt.preventDefault();
        $('.page-text-with-collection').fadeOut(600);
        $('.page-text-with-images').fadeOut(600);
        smoothScroll(hash);
    }

    function select(evt) {
        var hash = this.hash;
        var hash_collection = hash + "-collection"

        evt.preventDefault();
        $('.page-text-with-collection').fadeOut(0);
        $('.page-text-with-images').fadeOut(0);
        $(hash).fadeIn(600);
        $(hash_collection).fadeIn(600);
        smoothScroll(hash);
    }

    function scroll(evt) {
        var hash = this.hash;

        evt.preventDefault();
        smoothScroll(hash);
    }

})()

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#address_form_new');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  $('[js-address-edit]').on('click', function() {
    var formId = $(this).data('form-id');
    $('#address_form_' + formId).toggle();
    $('.account-address__edit').toggle();
    $('.account-address__listing').toggle();
  });

  $('[js-address-delete]').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '[js-show-recover]',
    hideRecoverPasswordLink: '[js-hide-recover]'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('.login__recover').toggle();
    $('.login__login').toggle();
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

theme.AccountDashboard = (function(){
  function AccountDashboard(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account__orders', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account__orders"]', this.$container).attr('aria-expanded', false);
        $('[aria-controls="account__information"]', this.$container).attr('aria-expanded', true);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account__orders, #account__information', this.$container).removeAttr('aria-hidden').removeAttr('style');
      }
    })
  }

  return AccountDashboard;
})();

theme.AccountAddress = (function(){
  function AccountAddress(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account-address-new', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account-address-new"]', this.$container).attr('aria-expanded', false);
        $('[aria-controls="account-address-list"]', this.$container).attr('aria-expanded', true);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account-address-new, #account-address-list', this.$container).removeAttr('aria-hidden').removeAttr('style')
      }
    })
  }

  return AccountAddress;
})();

theme.AccountOrders = (function(){
  function AccountOrders(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account-order__details', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account-order__details"]', this.$container).attr('aria-expanded', false);
        $('[aria-controls="account__order__overview"]', this.$container).attr('aria-expanded', true);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account-order__details, #account-order__overview', this.$container).removeAttr('aria-hidden').removeAttr('style')
      }
    })
  }

  return AccountOrders;
})();

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('accordion', theme.Accordion);
  sections.register('product', theme.Product);
  sections.register('related-products', theme.RelatedProducts);
  sections.register('collection', theme.Collection);
  sections.register('account-dashboard', theme.AccountDashboard);
  sections.register('account-address', theme.AccountAddress);
  sections.register('account-orders', theme.AccountOrders);
  sections.register('home-slider', theme.HomeSlider);
  sections.register('home-featured-collection', theme.HomeFeaturedCollection);
  sections.register('header-section', theme.Header);
  sections.register('video-hero', theme.CollabVideo);
  sections.register('mission-section', theme.missionSlick);
  sections.register('about-slider', theme.aboutSlider);
  sections.register('double-slider', theme.doubleSlider);
  sections.register('eye-shape-guide', theme.eyeShapeGuide);
  sections.register('bar-section', theme.Bar);
  

  //Initialize the slick slider for the Testimonials Slider section
  if( $('.testimonials-slider').length ){
    $('.testimonials-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            dots: true,
            cssEase: 'linear',
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    });
  }
  
  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // init mobile drawer
  theme.MobileNav.init();

  if (sessionStorage.getItem('filterOptionSelected') && $('.collection-content__collection-filters').length) {
    console.log("true");
    $('.collection-content__collection-filters').addClass('active');
    sessionStorage.removeItem('filterOptionSelected');
  }
});


// -------------------------------------
// Announcement Bar (iamota)
// -------------------------------------
// Check sessionStorage support and get announcementBarDismissed value
const isAnnouncementBarDismissed = () => {
    try {
        return sessionStorage.getItem('announcementBarDismissed') == getAnnouncementBarContent();
    } catch (e) {
        return false;
    }
};

// Get the plain text content of the announcement bar
const getAnnouncementBarContent = () => {
    const announcementBarContent = document.querySelector('.announcement-bar__content');
    if (!announcementBarContent) return '';
    
    return announcementBarContent.textContent.trim();
};

// Helper function to close the announcement bar
const closeAnnouncementBar = (announcementBar) => {
    console.log("CLOSE");
    announcementBar.classList.add('announcement-bar--hidden');
    announcementBar.setAttribute('aria-hidden', 'true');
    
    try {
        sessionStorage.setItem('announcementBarDismissed', getAnnouncementBarContent());
    } catch (e) {
        // sessionStorage not supported, do nothing
    }
};


// -------------------------------------
// Initialize
// -------------------------------------

// Hide the bar as early as possible
// TODO: consider moving this to a priority script loaded before the DOM to avoid CLS / flash of content
if (isAnnouncementBarDismissed()) {
    const style = document.createElement('style');
    style.innerHTML = '.announcement-bar { display: none; }';
    document.head.appendChild(style);
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {

  // if (isCartPage()) {
  //   window.location.href = '/?cart-open=true';
  // }
    
    // Annoucement Bar
    const announcementBar      = document.querySelector('.announcement-bar');
    const announcementBarClose = document.querySelector('.announcement-bar__close');
    
    if (!announcementBar) return; // Announcement Bar disabled

    if (isAnnouncementBarDismissed()) {
        closeAnnouncementBar(announcementBar);
    }

    announcementBarClose.addEventListener('click', (event) => {
        event.preventDefault();
        closeAnnouncementBar(announcementBar);
    });

    // Enable keyboard navigation
    announcementBarClose.addEventListener('keydown', (event) => {
        // Check if the key pressed is Enter or Space
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            closeAnnouncementBar(announcementBar);
        }
    });
});

// Sticky bundle builder
window.addEventListener('scroll', () => {
    const bundleBuilder = document.querySelector('.bundle-builder');

    if (!bundleBuilder) return;

    const viewTop = window.pageYOffset || document.documentElement.scrollTop;
    const _top = bundleBuilder.offsetTop - 60;

    if (viewTop >= _top) {
        bundleBuilder.classList.add('is-sticky');
    } else {
        bundleBuilder.classList.remove('is-sticky');
    }
});